import { render } from "./UserDescription.vue?vue&type=template&id=0724a5c0"
import script from "./UserDescription.vue?vue&type=script&lang=js"
export * from "./UserDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/common/user/UserDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0724a5c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0724a5c0', __exports__)) {
    api.reload('0724a5c0', __exports__)
  }
  
  module.hot.accept("./UserDescription.vue?vue&type=template&id=0724a5c0", () => {
    api.rerender('0724a5c0', render)
  })

}


export default __exports__